import {useEffect, useState} from 'react'
import {getHasGeolocationPermission} from 'utils/geolocation'

const useHasGeolocationPermission = () => {
  const [permitted, setPermitted] = useState<boolean>()

  useEffect(() => {
    if (navigator.permissions) {
      const setPermissionStatus = async () => {
        const hasPermission = await getHasGeolocationPermission()
        setPermitted(hasPermission)
      }
      setPermissionStatus()
    }
  }, [permitted])

  return permitted
}

export default useHasGeolocationPermission
